import {CtModelRouteData} from "@ctsolution/ct-framework";

export const CompanyRouteData = (): CtModelRouteData => CtModelRouteData
  .create()
  .setController("company");
